import mapboxgl from 'mapbox-gl';

const geocodingCache = new Map();

export async function getAddressFromCoordinates(longitude, latitude) {
  const cacheKey = `${longitude.toFixed(6)},${latitude.toFixed(6)}`;

  if (geocodingCache.has(cacheKey)) {
    return geocodingCache.get(cacheKey);
  }

  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${mapboxgl.accessToken}&language=pt&types=address,poi`
    );

    if (!response.ok) {
      throw new Error('Erro ao buscar endereço');
    }

    const data = await response.json();

    if (data.features && data.features.length > 0) {
      const feature = data.features[0];
      let address = feature.place_name;

      if (address.includes(',')) {
        const parts = address.split(',');
        address = parts.slice(0, 2).join(',').trim();
      }

      geocodingCache.set(cacheKey, address);
      return address;
    }

    const fallback = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
    geocodingCache.set(cacheKey, fallback);
    return fallback;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Erro no geocoding reverso:', error);
    const fallback = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
    geocodingCache.set(cacheKey, fallback);
    return fallback;
  }
}

export function clearGeocodingCache() {
  geocodingCache.clear();
}
